// extracted by mini-css-extract-plugin
var _1 = "NaxLSL";
export { _1 as "backgroundModal" }
